import type { TWeather } from '@/types';

type WeatherType = "swellHeight" | "windSpeed" ;

export function getForecastColorsFromWeatherHours(hours: TWeather[], weatherType: WeatherType): string[] {

  const weatherLevels: Record<WeatherType, { low: number; high: number }> = {
     "swellHeight": { "low": 1, "high": 1.5 }, 
     "windSpeed": { "low": 10, "high": 20 }
    };

  const weatherLevel = weatherLevels[weatherType];

  const daily: Record<string, TWeather> = {};
  for (const hour of hours) {
    const date = hour.time.split('T')[0];
    if (!daily[date]) daily[date] = hour;
  }

  return Object.values(daily)
    .slice(0, 10)
    .map(hour => {
      const weatherValues = Object.values((hour as any)[weatherType] ?? {});

      if (weatherValues.length === 0) return 'gray';

      const freq = new Map<number, number>();
      for (const v of weatherValues) {
        const numV = Number(v);
        if (!isNaN(numV)) {
          freq.set(numV, (freq.get(numV) || 0) + 1);
        }
      }

      const modal = [...freq.entries()].sort((a, b) => b[1] - a[1] || a[0] - b[0])[0][0];

      if (modal < weatherLevel.low) return '#30b78c';
      if (modal > weatherLevel.high) return '#f37d77';
      return 'orange';
    });
}

